import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import App from './App'
import './styles/index.css'
import { initializeGTM } from './utils/gtm'

const CPDashboard = React.lazy(() => import('./pages/CPDashboard'))
const SalesCareHomes = React.lazy(() => import('./pages/SalesCareHomes'))
const SalesMap = React.lazy(() => import('./pages/SalesMap'))
const SalesAuthGuard = React.lazy(() => import('./auth/SalesAuthGuard'))

// Initialize Google Tag Manager (production only)
initializeGTM();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/cp_dashboard" element={<CPDashboard />} />
          <Route path="/sales_carehomes" element={
            <SalesAuthGuard>
              <SalesCareHomes />
            </SalesAuthGuard>
          } />
          <Route path="/sales_map" element={
            <SalesAuthGuard>
              <SalesMap />
            </SalesAuthGuard>
          } />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
) 